module.exports = __webpack_public_path__ + "img/goal05.7b272cb2.png";